
<template>
  <div>

    <base-card :with_title="false" :with_actions="false">
      <template slot="content">

        <document-create class="my-5" @done="handleDocCreated" :company_id="company_id" :project_id="project_id" :model_used="model_used"></document-create>

        <v-data-table
          :headers="headers"
          :items="documents"
          class="elevation-0"
          :loading="loading_data"
          :options.sync="options"
          :server-items-length="total_data"
          :footer-props="{itemsPerPageOptions: [15,25,50]}"
          mobile-breakpoint="1"
          ref='table'
          mobile_breakpoint="1"
        >
          <template v-slot:header.name="{ header }">
            <span>
              {{ header.text }}
              <sort-filter-table :header="header" @sentFilter="handleSentFilter"></sort-filter-table>
            </span>
          </template>

          <template v-slot:header.tag_list="{ header }">
            <span>
              {{ header.text }}
              <sort-filter-table :header="header" @sentFilter="handleSentFilter"></sort-filter-table>
            </span>
          </template>

          <template v-slot:header.created_at="{ header }">
            <span>
              {{ header.text }}
              <sort-filter-table :header="header" :use_search="false" use_date
                @sentFilter="handleSentFilter"
              ></sort-filter-table>
            </span>
          </template>


          
          <template v-slot:item.created_at="{item}">
            {{ $dayjs(item.created_at).format('DD/MM/YYYY') }}
          </template>

          <template v-slot:item.project_id="{item}">
            <v-btn small rounded v-if="item.project_id" text color="primary" :to="{name: 'OneProject', params: {id: item.project_id}}">
              <v-icon small left>mdi-open-in-new</v-icon>
              {{ item.project_id }}
            </v-btn>

          </template>
          
          <template v-slot:item.file_size="{item}">
            {{ formatBytes(item.file_size) }}
          </template>
          
          <template v-slot:item.actions="{item}">
            <v-btn icon small color="grey darken-2" :disabled="!item.file_url"
            :href="item.file_url" target="_blank"
            >
              <v-icon small>mdi-download</v-icon>
            </v-btn>
            <v-btn icon small color="grey darken-2" @click="deleteDocument(item)">
              <v-icon small>mdi-delete</v-icon>
            </v-btn>
          </template>
        </v-data-table>

      </template>
    </base-card>

  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
// import validations from '@/mixins/validations'
import Api from '@/api/index';
import DocumentCreate from './DocumentCreate.vue';
import TablePagination from '@/mixins/table_pagination.js';

export default {
  name: 'DocumentList',
  mixins: [ TablePagination ],
  props: {
    model_used: { // project, company
      type: String, 
    },
    company_id: {
      type: [String, Number]
    },
    project_id: {
      type: [String, Number]
    }
  },
  components: {
    DocumentCreate
    //ComponentName: () => import(''),
  },
  data() {
    return {
      loading: false,
      documents: [],
      headers: [
        {text: this.$t('name'), value: 'name', sortable: false},
        {text: this.$t('file_size'), value: 'file_size', sortable: false},
        {text: this.$t('file_format'), value: 'file_kind', sortable: false},
        {text: this.$t('created_at'), value: 'created_at', sortable: false},
        {text: this.$t('projects.project'), value: 'project_id', sortable: false},
        {text: this.$t('tags'), value: 'tag_list', sortable: false, search_field: 'tags_name'},
        {text: this.$t('action'), value: 'actions', sortable: false},
      ],

      local_filter: {},

      status_options: [
        {text: this.$t('financials.statuses.open'), value: '1'},
        {text: this.$t('financials.statuses.payed'), value: '10'},
        {text: this.$t('financials.statuses.overdue'), value: '20'},
        {text: this.$t('financials.statuses.canceled'), value: '30'},
      ],
      kind_options: [
        {text: this.$t('financials.kinds.income'), value: '1'},
        {text: this.$t('financials.kinds.outcome'), value: '10'},
      ],

    }
  },
  methods: {
    handleSentFilter(e){
      // if (this.user.kind == 'supplier') {
      //   this.local_filter = {...this.local_filter, supplier_id: this.user.dept_ids[0]}
      // }

      let {sorts, searches, ...rest} = this.local_filter
      sorts = sorts || [] 
      searches = searches || [] 

      this.local_filter = {
        ...rest,
        ...e,
        // sorts: [...new Set([...sorts, ...e.sorts])],
        searches: {...searches, ...e.searches},
        sorts: {...sorts, ...e.sorts},
      }
      if (!Object.values(e.searches)[0]){
        delete this.local_filter.searches[Object.keys(e.searches)[0]]
      }
      if (!Object.values(e.searches)[1]){
        delete this.local_filter.searches[Object.keys(e.searches)[1]]
      }
      if (!Object.values(e.sorts)[0]){
        delete this.local_filter.sorts[Object.keys(e.sorts)[0]]
      }

      this.getDocuments()
    },
    getDocuments(){
      this.options.page = 1;
      this.default_source_kind = 'local'

      if (this.project_id) {
        this.local_filter = {
          ...this.local_filter,
          project_id: this.project_id
        }
      } 

      if (this.company_id) {
        this.local_filter = {
          ...this.local_filter,
          company_id: this.company_id
        }
      }

      this.getDataFromApi(
        'Document',
        'index',
        'documents',
        'data',
        'total',
        {
          ...this.local_filter
        }
      )
    },
    downladDocument(item){
      this.$router.push({name: 'ShowDocument', params: {id: item.id}})
    },
    deleteDocument(item){
      this.loading = true
      Api.Document.delete(item.id).then(r=>r.data).then(d=> {
        this.getDocuments()
      }).catch(err=> {
        console.log({err});
      }).finally(()=>{
        this.loading = false
      })
    },
    handleDocCreated(){
      this.getDocuments()
    },
    formatBytes(bytes, decimals = 2) {
      if (!+bytes) return '0 B'

      const k = 1024
      const dm = decimals < 0 ? 0 : decimals
      const sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']

      const i = Math.floor(Math.log(bytes) / Math.log(k))

      return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`
    },

    ...mapActions({
      // function: 'Module/action'
      //addNotification: 'Notification/add'
    })
  },
  computed: {
    ...mapState({
      // data: state=> state.Module.state_var
    })
  },
  mounted () {
    this.getDocuments();
  },
}
</script>

<style scoped>

</style>